import { render, staticRenderFns } from "./beastsLair.vue?vue&type=template&id=56f2cd7b&"
import script from "./beastsLair.vue?vue&type=script&lang=js&"
export * from "./beastsLair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports